/**
 * Amber Vale Home — Refer-a-Friend Widget
 */

(function () {
  'use strict';

  const _config = window.AmberValeReferral || {};
  if (!_config.customerId) return;

  const CONFIG = Object.assign({
    position: 'middle-right',
    referrerReward: 10,
    friendReward: 10,
    brandColor: '#D6781C',
    accentColor: '#2C2C2C',
    triggerLabel: 'Give $10, Get $10',
    appEndpoint: '/apps/amber-vale-referral',
    shopDomain: window.Shopify?.shop || '',
    customerId: null,
    customerEmail: '',
    customerName: '',
  }, window.AmberValeReferral || {});

  const POSITIONS = {
    'bottom-right': { bottom: '24px', right: '24px', top: 'auto', left: 'auto' },
    'bottom-left':  { bottom: '24px', left: '24px',  top: 'auto', right: 'auto' },
    'middle-right': { top: '50%', right: '0', bottom: 'auto', left: 'auto' },
    'middle-left':  { top: '50%', left: '0', bottom: 'auto', right: 'auto' },
  };

  const pos = POSITIONS[CONFIG.position] || POSITIONS['bottom-right'];
  const tabClass = CONFIG.position === 'middle-right' ? 'av-tab-right'
                 : CONFIG.position === 'middle-left'  ? 'av-tab-left' : '';

  const style = document.createElement('style');
  style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600&family=Jost:wght@300;400;500&display=swap');

    #av-referral-root * { box-sizing: border-box !important; margin: 0 !important; padding: 0 !important; line-height: normal !important; -webkit-font-smoothing: antialiased !important; }

    #av-referral-trigger {
      position: fixed !important;
      z-index: 9998 !important;
      ${Object.entries(pos).map(([k,v]) => `${k.replace(/([A-Z])/g,'-$1').toLowerCase()}:${v} !important`).join(';')};
      background: ${CONFIG.brandColor} !important;
      color: #fff !important;
      border: none !important;
      cursor: pointer !important;
      padding: 12px 20px !important;
      font-family: 'Jost', sans-serif !important;
      font-size: 13px !important;
      font-weight: 500 !important;
      letter-spacing: 0.08em !important;
      text-transform: uppercase !important;
      border-radius: 2px !important;
      box-shadow: 0 4px 20px rgba(0,0,0,0.18) !important;
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      transition: background 0.2s !important;
      text-decoration: none !important;
    }
    #av-referral-trigger:hover { background: #b8601a !important; }
    #av-referral-trigger svg { width: 16px !important; height: 16px !important; flex-shrink: 0 !important; }
    #av-referral-trigger.av-tab-right, #av-referral-trigger.av-tab-left { border-radius: 2px 2px 0 0 !important; padding: 10px 16px !important; }
    #av-referral-trigger.av-tab-right { transform: rotate(-90deg) translateX(calc(50% - 4px)) !important; transform-origin: right bottom !important; right: 0 !important; }
    #av-referral-trigger.av-tab-left  { transform: rotate(90deg) translateX(calc(-50% + 4px)) !important; transform-origin: left bottom !important; left: 0 !important; }

    /* Mobile: switch the rotated side-tab to a normal horizontal button pinned bottom-left
       (bottom-right is occupied by the "Get 15% Off" tab) */
    @media (max-width: 768px) {
      #av-referral-trigger,
      #av-referral-trigger.av-tab-right,
      #av-referral-trigger.av-tab-left {
        transform: none !important;
        top: auto !important;
        bottom: 16px !important;
        left: 16px !important;
        right: auto !important;
        border-radius: 2px !important;
        padding: 12px 18px !important;
      }
      #av-referral-modal {
        margin: 12px !important;
        max-height: 90vh !important;
        overflow-y: auto !important;
      }
    }

    #av-referral-overlay { display: none !important; position: fixed !important; top:0 !important; left:0 !important; right:0 !important; bottom:0 !important; background: rgba(20,16,12,0.5) !important; z-index: 99999 !important; backdrop-filter: blur(2px) !important; }
    #av-referral-overlay.av-open { display: flex !important; align-items: center !important; justify-content: center !important; animation: av-fade-in 0.2s ease !important; }

    @keyframes av-fade-in  { from { opacity:0 } to { opacity:1 } }
    @keyframes av-slide-up { from { opacity:0; transform:translateY(20px) } to { opacity:1; transform:translateY(0) } }

    #av-referral-modal { background: #FDFAF6 !important; width: 100% !important; max-width: 500px !important; margin: 20px !important; border-radius: 6px !important; overflow: hidden !important; box-shadow: 0 24px 64px rgba(0,0,0,0.22) !important; animation: av-slide-up 0.3s cubic-bezier(0.16,1,0.3,1) !important; position: relative !important; }

    #av-referral-modal .av-modal-header { background: ${CONFIG.brandColor} !important; padding: 32px 32px 28px !important; color: #fff !important; position: relative !important; }
    #av-referral-modal .av-modal-header h2 { font-family: 'Cormorant Garamond', serif !important; font-size: 30px !important; font-weight: 600 !important; line-height: 1.2 !important; color: #fff !important; margin-bottom: 8px !important; padding: 0 !important; text-transform: none !important; letter-spacing: normal !important; border: none !important; }
    #av-referral-modal .av-modal-header p { font-family: 'Jost', sans-serif !important; font-size: 14px !important; font-weight: 300 !important; opacity: 0.92 !important; letter-spacing: 0.02em !important; margin-bottom: 20px !important; color: #fff !important; padding: 0 !important; }

    #av-referral-modal .av-reward-badges { display: flex !important; gap: 12px !important; padding: 0 !important; }
    #av-referral-modal .av-badge { flex: 1 !important; background: rgba(255,255,255,0.15) !important; border: 1px solid rgba(255,255,255,0.35) !important; border-radius: 4px !important; padding: 14px 16px !important; text-align: center !important; }
    #av-referral-modal .av-badge-amount { font-family: 'Cormorant Garamond', serif !important; font-size: 36px !important; font-weight: 600 !important; color: #fff !important; line-height: 1 !important; display: block !important; margin-bottom: 4px !important; padding: 0 !important; }
    #av-referral-modal .av-badge-label { font-family: 'Jost', sans-serif !important; font-size: 11px !important; font-weight: 500 !important; letter-spacing: 0.1em !important; text-transform: uppercase !important; color: rgba(255,255,255,0.85) !important; display: block !important; padding: 0 !important; }

    #av-referral-modal .av-close { position: absolute !important; top: 14px !important; right: 16px !important; background: none !important; border: none !important; color: rgba(255,255,255,0.8) !important; cursor: pointer !important; font-size: 24px !important; line-height: 1 !important; padding: 4px !important; width: auto !important; transition: color 0.15s !important; }
    #av-referral-modal .av-close:hover { color: #fff !important; }

    #av-referral-modal .av-modal-body { padding: 24px 28px 28px !important; background: #FDFAF6 !important; }
    #av-referral-modal .av-field { margin-bottom: 14px !important; padding: 0 !important; }
    #av-referral-modal .av-field input,
    #av-referral-modal .av-field textarea {
      width: 100% !important; border: 1px solid #DDD !important; border-radius: 4px !important;
      padding: 13px 16px !important; font-family: 'Jost', sans-serif !important; font-size: 14px !important;
      color: #2C2C2C !important; background: #fff !important; outline: none !important;
      box-shadow: none !important; appearance: none !important; -webkit-appearance: none !important;
      display: block !important; margin: 0 !important; transition: border-color 0.15s, box-shadow 0.15s !important;
      height: auto !important;
    }
    #av-referral-modal .av-field input::placeholder,
    #av-referral-modal .av-field textarea::placeholder { color: #AAA !important; font-family: 'Jost', sans-serif !important; font-weight: 400 !important; font-size: 13px !important; letter-spacing: 0.04em !important; opacity: 1 !important; }
    #av-referral-modal .av-field input:focus,
    #av-referral-modal .av-field textarea:focus { border-color: ${CONFIG.brandColor} !important; box-shadow: 0 0 0 3px rgba(214,120,28,0.12) !important; outline: none !important; }
    #av-referral-modal .av-field textarea { resize: vertical !important; min-height: 80px !important; }
    #av-referral-modal .av-field .av-error { color: #c0392b !important; font-size: 11px !important; margin-top: 4px !important; display: none !important; padding: 0 !important; }
    #av-referral-modal .av-field.av-has-error input,
    #av-referral-modal .av-field.av-has-error textarea { border-color: #c0392b !important; }
    #av-referral-modal .av-field.av-has-error .av-error { display: block !important; }

    #av-referral-modal .av-submit {
      width: 100% !important; background: ${CONFIG.brandColor} !important; color: #fff !important;
      border: none !important; padding: 15px 24px !important; font-family: 'Jost', sans-serif !important;
      font-size: 14px !important; font-weight: 500 !important; letter-spacing: 0.1em !important;
      text-transform: uppercase !important; border-radius: 4px !important; cursor: pointer !important;
      margin-top: 6px !important; box-shadow: 0 4px 14px rgba(214,120,28,0.35) !important;
      display: block !important; text-align: center !important;
      transition: background 0.2s, transform 0.15s, box-shadow 0.15s !important;
    }
    #av-referral-modal .av-submit:hover { background: #b8601a !important; transform: translateY(-1px) !important; box-shadow: 0 6px 18px rgba(214,120,28,0.4) !important; }
    #av-referral-modal .av-submit:disabled { opacity: 0.6 !important; cursor: not-allowed !important; }

    #av-referral-modal .av-disclaimer { font-family: 'Jost', sans-serif !important; font-size: 11px !important; color: #AAA !important; text-align: center !important; margin-top: 12px !important; line-height: 1.5 !important; padding: 0 !important; }

    #av-referral-modal .av-success { display: none !important; text-align: center !important; padding: 48px 32px !important; }
    #av-referral-modal .av-success.av-open { display: block !important; }
    #av-referral-modal .av-success-icon { width: 60px !important; height: 60px !important; background: ${CONFIG.brandColor} !important; border-radius: 50% !important; display: flex !important; align-items: center !important; justify-content: center !important; margin: 0 auto 20px !important; box-shadow: 0 4px 16px rgba(214,120,28,0.3) !important; }
    #av-referral-modal .av-success-icon svg { width: 28px !important; height: 28px !important; color: #fff !important; }
    #av-referral-modal .av-success h3 { font-family: 'Cormorant Garamond', serif !important; font-size: 26px !important; margin-bottom: 10px !important; color: #2C2C2C !important; padding: 0 !important; }
    #av-referral-modal .av-success p { font-family: 'Jost', sans-serif !important; font-size: 14px !important; color: #666 !important; line-height: 1.6 !important; padding: 0 !important; }

    .av-spinner { display: inline-block !important; width: 14px !important; height: 14px !important; border: 2px solid rgba(255,255,255,0.4) !important; border-top-color: #fff !important; border-radius: 50% !important; animation: av-spin 0.6s linear infinite !important; vertical-align: middle !important; margin-right: 6px !important; }
    @keyframes av-spin { to { transform: rotate(360deg) } }
  `;
  document.head.appendChild(style);

  const root = document.createElement('div');
  root.id = 'av-referral-root';

  root.innerHTML = `
    <button id="av-referral-trigger" class="${tabClass}" aria-label="Refer a friend">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
      ${CONFIG.triggerLabel}
    </button>

    <div id="av-referral-overlay" role="dialog" aria-modal="true" aria-labelledby="av-modal-title">
      <div id="av-referral-modal">
        <div class="av-modal-header">
          <button class="av-close" aria-label="Close">×</button>
          <h2 id="av-modal-title">Share the love,<br>share the savings.</h2>
          <p>Refer a friend to Amber Vale Home and you both receive a reward.<br>Refer as many friends as you would like.</p>
          <div class="av-reward-badges">
            <div class="av-badge">
              <span class="av-badge-amount">$${CONFIG.referrerReward}</span>
              <span class="av-badge-label">You Receive</span>
            </div>
            <div class="av-badge">
              <span class="av-badge-amount">$${CONFIG.friendReward}</span>
              <span class="av-badge-label">Friend Receives</span>
            </div>
          </div>
        </div>

        <div class="av-modal-body" id="av-form-wrap">
          <div class="av-field" id="field-fname">
            <input type="text" id="av-fname" placeholder="Friend's Name" autocomplete="off">
            <div class="av-error">Please enter your friend's name.</div>
          </div>
          <div class="av-field" id="field-femail">
            <input type="email" id="av-femail" placeholder="Friend's Email" autocomplete="off">
            <div class="av-error">Please enter a valid email address.</div>
          </div>
          <div class="av-field" id="field-remail">
            <input type="email" id="av-remail" placeholder="Your Email" autocomplete="email">
            <div class="av-error">Please enter your email address.</div>
          </div>
          <div class="av-field">
            <textarea id="av-message" placeholder="Personal Message (Optional) — Hey! I love shopping at Amber Vale Home and thought you would too…"></textarea>
          </div>
          <button class="av-submit" id="av-submit-btn">Send My Referral</button>
          <p class="av-disclaimer">Your friend will receive an email with a $${CONFIG.friendReward} gift. You'll receive your $${CONFIG.referrerReward} reward once they make their first purchase.</p>
        </div>

        <div class="av-success" id="av-success-wrap">
          <div class="av-success-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          </div>
          <h3>Referral Sent!</h3>
          <p>We've sent your friend an invitation. Once they make their first purchase, your $${CONFIG.referrerReward} reward will be on its way.</p>
        </div>
      </div>
    </div>
  `;

  document.body.appendChild(root);

  const trigger   = document.getElementById('av-referral-trigger');
  const overlay   = document.getElementById('av-referral-overlay');
  const closeBtn  = overlay.querySelector('.av-close');
  const submitBtn = document.getElementById('av-submit-btn');
  const formWrap  = document.getElementById('av-form-wrap');
  const successWrap = document.getElementById('av-success-wrap');

  function openModal() { overlay.classList.add('av-open'); document.body.style.overflow = 'hidden'; }
  function closeModal() { overlay.classList.remove('av-open'); document.body.style.overflow = ''; }

  trigger.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });

  function validateField(fieldId, inputId, test) {
    const field = document.getElementById(fieldId);
    const val = document.getElementById(inputId).value.trim();
    const ok = test(val);
    field.classList.toggle('av-has-error', !ok);
    return ok;
  }

  submitBtn.addEventListener('click', async () => {
    const okFName  = validateField('field-fname',  'av-fname',  v => v.length > 0);
    const okFEmail = validateField('field-femail', 'av-femail', v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v));
    const okREmail = validateField('field-remail', 'av-remail', v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v));
    if (!okFName || !okFEmail || !okREmail) return;

    const payload = {
      friend_name:    document.getElementById('av-fname').value.trim(),
      friend_email:   document.getElementById('av-femail').value.trim(),
      referrer_email: document.getElementById('av-remail').value.trim(),
      referrer_name:  CONFIG.customerName || '',
      customer_id:    CONFIG.customerId,
      message:        document.getElementById('av-message').value.trim(),
      shop:           CONFIG.shopDomain,
    };

    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="av-spinner"></span>Sending…';

    try {
      const res = await fetch(`${CONFIG.appEndpoint}/api/referral`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Something went wrong.');
      formWrap.style.display = 'none';
      successWrap.classList.add('av-open');
    } catch (err) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Send My Referral';
      alert('Oops — ' + err.message + '\nPlease try again.');
    }
  });

})();